import { render, staticRenderFns } from "./DetailSub.vue?vue&type=template&id=1c042c22&"
import script from "./DetailSub.vue?vue&type=script&lang=js&"
export * from "./DetailSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports